import {
  BoatIcon,
  BusIcon, GroupIcon, IndividualIcon,
  InRoomIcon,
  SubBoardsIcon,
  TransportationMethodOtherIcon
} from "@kursk/components/ui/icons.astrakhan";
import { CarIcon, WalkIcon } from "@kursk/components/ui/icons";

const EXCURSION_TRANSPORTATION_METHOD_HASHES = {
  other: {
    icon: <TransportationMethodOtherIcon />,
    title: 'Другое',
  },
  walk: {
    icon: <WalkIcon />,
    title: 'Пешеходный'
  },
  room: {
    icon: <InRoomIcon />,
    title: 'В помещении',
  },
  bus: {
    icon: <BusIcon />,
    title: 'На автобусе',
  },
  auto: {
    icon: <CarIcon />,
    title: 'Автомобильный',
  },
  supBoards: {
    icon: <SubBoardsIcon />,
    title: 'На сап-бордах',
  },
  boat: {
    icon: <BoatIcon />,
    title: 'На теплоходе',
  },
}

const EXCURSION_TRANSPORTATION_METHOD_TITLES = Object.entries(EXCURSION_TRANSPORTATION_METHOD_HASHES)
  .reduce((acc, [key, { title }]) => {
    acc[key] = title;

    return acc;
  }, {});

const EXCURSION_TYPE_HASHES = {
  individual: {
    icon: <IndividualIcon />,
    title: 'Индивидуальный',
  },
  group: {
    icon: <GroupIcon />,
    title: 'Групповой'
  }
}

const EXCURSION_TYPE_TITLES = Object.entries(EXCURSION_TYPE_HASHES)
  .reduce((acc, [key, { title }]) => {
    acc[key] = title;

    return acc;
  }, {});

export const EXCURSION_SINGLE_HASHES = {
  transportationMethod: EXCURSION_TRANSPORTATION_METHOD_HASHES,
  type: EXCURSION_TYPE_HASHES
}

export const EXCURSION_MULTIPLE_HASHES = {
  transportationMethod: {
    icon: <TransportationMethodOtherIcon />,
    titles: EXCURSION_TRANSPORTATION_METHOD_TITLES
  },
  type: {
    icon: <GroupIcon />,
    titles: EXCURSION_TYPE_TITLES
  }
}
